import MUICheckbox, { CheckboxProps as MUICheckboxProps } from '@material-ui/core/Checkbox';
import styles from '../../../styles/components/inputs/Checkbox.module.css';

export default function Checkbox(props: MUICheckboxProps) {
  return <MUICheckbox {...props} classes={{ checked: styles.checked, root: styles.checkbox }} />;
}
